export var MODAL_PIPELINE_ERROR='MODAL_PIPELINE_ERROR';